/**
 * Date / establishment filters for the resources stacked chart.
 */

import * as React from 'react';
import { KpiFilters } from '@/components/kpi/KpiFilters';
import type { ChartFilterVisibility } from '@/components/charts/chart-configs';
import type { DashboardStatsDateFilterState } from '@/utils/dashboard-stats-date-range-utils';

/** Props for {@link ResourcesChartFilters}. */
interface ResourcesChartFiltersProps {
  filters: DashboardStatsDateFilterState;
  onChange: (next: DashboardStatsDateFilterState) => void;
  visibility: ChartFilterVisibility;
}

/** Resources-chart filter bar (period, dates, establishment). */
export const ResourcesChartFilters: React.FC<ResourcesChartFiltersProps> = ({
  filters,
  onChange,
  visibility,
}) => (
  <div className="filter-groups-container mb-5">
    <KpiFilters
      filters={filters}
      onChange={onChange}
      showPeriodFilter={visibility.showPeriodFilter}
      showDateRangeFilter={visibility.showDateRangeFilter}
      showEstablishmentFilter={visibility.showEstablishmentFilter}
    />
  </div>
);
